import { FormContainer } from "./integration-consult/FormContainer";
import { FormSubmitButton } from "./integration-consult/FormSubmitButton";
import { CompanyFields, ContactFields, SystemFields, SchedulingFields } from "./integration-consult/FormFields";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { formSchema, FormData } from "./form-utils/formValidation";
import { useState } from "react";

interface IntegrationConsultFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const IntegrationConsultForm = ({ open, onOpenChange }: IntegrationConsultFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const form = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      companyName: "",
      teamSize: "",
      contactName: "",
      role: "",
      email: "",
      phone: "",
      currentSystems: "",
      integrationNeeds: "",
      preferredDate: "",
      budgetRange: "",
    },
  });

  const handleSubmit = async (data: FormData) => {
    setIsSubmitting(true);
    
    try {
      // Simulate form submission
      await new Promise(resolve => setTimeout(resolve, 2000));
      console.log("Form submitted:", data);
      onOpenChange(false);
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormContainer 
      open={open} 
      onOpenChange={onOpenChange}
      isSubmitting={isSubmitting}
      title="Schedule Integration Consultation"
    >
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
        <CompanyFields form={form} />
        <ContactFields form={form} />
        <SystemFields form={form} />
        <SchedulingFields form={form} />
        
        <FormSubmitButton 
          isSubmitting={isSubmitting}
          text="Schedule Consultation"
          loadingText="Scheduling..."
        />
      </form>
    </FormContainer>
  );
};